import { useQuery } from '@tanstack/react-query';
import { getMfaFactors } from '../api/mfa';

export const MFA_FACTORS_QUERY_KEY = ['mfa-factors'];

export default function useMfaFactors() {
  const query = useQuery({
    queryKey: MFA_FACTORS_QUERY_KEY,
    queryFn: getMfaFactors,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  const factors = query.data?.factors || [];
  const smsFactor = factors.find(f => f.type === 'sms' && f.status?.toUpperCase() === 'ACTIVE') || null;
  const totpFactor = factors.find(f => f.type === 'totp' && f.status?.toUpperCase() === 'ACTIVE') || null;

  return {
    factors,
    smsFactor,
    isSmsMfaEnabled: !!smsFactor,
    totpFactor,
    isTotpEnabled: !!totpFactor,
    isLoading: query.isLoading || query.isFetching,
    error: query.error,
    refetch: query.refetch,
  };
}
